// Wem gehört ein Tastendruck, während ein Anruf läuft?
//
// Der Hintergrund ist ein echter Fehler, kein Feinschliff. Seit UMBAU.md Phase 4 verlässt der
// Wählklick die Seite nicht mehr — der Telefon-Stapel bleibt also UNTER dem Cockpit gemountet, samt
// seinem eigenen `window`-Tastaturhandler (`LeadStack.tsx`). Der liest:
//
//   ←  ablehnen        →  übernehmen        Leertaste  überspringen        ⌫  eine Karte zurück
//
// Beide Handler hängen am selben `window`, und `preventDefault` hält den anderen nicht auf. Wer im
// Skript blätterte, fällte damit nebenbei Stapel-Entscheidungen, die er nie gesehen hat. Das Cockpit
// nimmt seine Tasten deshalb in der CAPTURE-Phase entgegen und stoppt sie dort.
//
// `Escape` gehört ABSICHTLICH nicht dazu: es heisst überall „schliessen", und ein Dialog, den man
// nicht mehr wegbekommt, wäre schlimmer als der doppelte Griff.
const COCKPIT_TASTEN = new Set([
  'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', ' ', 'Enter', 'Backspace',
  '1', '2', '3', '4', '5', '6', '7', '8', '9',
  // 'm' seit 2026-08-15: im Gespräch öffnet es das Mail-Pult („schicken Sie mir mal was"), im
  // Abschluss ist es die Mailbox-Disposition. Beide gehören dem Cockpit — ohne diese Zeile fiele
  // der Tastendruck zusätzlich in den Stapel darunter.
  'w', 'l', 'f', 'n', 'g', 'b', 's', 'x', 'i', 'm',
  // Die Buchstabenreihe der ABLEHNUNGEN (seit 2026-08-21). Ohne sie fiele ein „q" oder „o" als
  // Tastendruck in den Telefon-Stapel darunter — genau der Griff, gegen den diese Datei gebaut ist.
  // Das I fehlt in der Reihe (es gehoert der Info), steht aber ohnehin schon eine Zeile hoeher.
  'q', 'e', 'r', 't', 'z', 'u', 'o', 'p',
  // Schriftgrad im Cockpit (seit 2026-08-21). '=' ist '+' ohne Umschalt, '_' ist '-' mit ihr —
  // beide mitgenommen, damit die Taste unabhaengig vom Tastaturlayout dasselbe tut. '0' setzt
  // zurueck; die Ziffern 1-9 gehoeren daneben schon den Einwaenden.
  '+', '=', '-', '_', '0',
]);

/** Beansprucht das offene Cockpit diese Taste für sich (→ nicht an die Seite darunter weiterreichen)?
 *
 * `tippt` = der Fokus steht in einem Text-Feld (Notiz, Info-Formular). Dort gehört JEDE Taste dem
 * Feld — sonst könnte man in einer Notiz kein „s" schreiben, ohne den Abschluss zu öffnen.
 */
export function gehoertDemCockpit(key: string, tippt: boolean): boolean {
  if (tippt) return false;
  return COCKPIT_TASTEN.has(key.length === 1 ? key.toLowerCase() : key);
}
